export default "__VITE_ASSET__cd6QjvmU__"